import {
  CarrierType,
  RailVisitResponseDto,
  StowageInstructionDto,
  VesselVisitDto,
} from '@planning/app/api'
import { FieldStore, ISubFormStore } from '@tom-ui/utils'
import { action, makeObservable, observable } from 'mobx'

export type ActionChoice = 'keep' | 'edit' | 'clear'

export class OutboundSubFormStore implements ISubFormStore<any> {
  carrierVisit: FieldStore<VesselVisitDto | RailVisitResponseDto | null | undefined>
  carrierType: FieldStore<CarrierType | null | undefined>
  finalDestination: FieldStore<string | null | undefined>
  inlandDestination: FieldStore<string | null | undefined>
  portOfDischarge: FieldStore<string | null | undefined>
  stowageInstructions: FieldStore<StowageInstructionDto | null | undefined>
  approvalForLoading: FieldStore<boolean | null | undefined>

  carrierTypeChoice: ActionChoice = 'keep'
  visitChoice: ActionChoice = 'keep'

  constructor() {
    this.carrierVisit = new FieldStore<VesselVisitDto | RailVisitResponseDto | null | undefined>(
      undefined,
    )
    this.carrierType = new FieldStore<CarrierType | null | undefined>(undefined)
    this.finalDestination = new FieldStore<string | null | undefined>(undefined)
    this.inlandDestination = new FieldStore<string | null | undefined>(undefined)
    this.portOfDischarge = new FieldStore<string | null | undefined>(undefined)
    this.stowageInstructions = new FieldStore<StowageInstructionDto | null | undefined>(undefined)
    this.approvalForLoading = new FieldStore<boolean | null | undefined>(undefined)

    makeObservable(this, {
      visitChoice: observable,
      carrierTypeChoice: observable,
      setCarrierTypeChoice: action,
      setVisitChoice: action,
    })
  }

  validate = () => {
    let isFormValid = true
    const requiredError = 'Field is required'

    if (this.carrierTypeChoice === 'edit' && !this.carrierType.value) {
      this.carrierType.setError(requiredError)
      isFormValid = false
    } else {
      this.carrierType.setError(undefined)
    }

    const requiresVisit =
      !this.carrierType.value ||
      (this.carrierType.value !== CarrierType.Universal &&
        this.carrierType.value !== CarrierType.Truck)

    if (this.visitChoice === 'edit' && requiresVisit) {
      if (!this.carrierVisit.value) {
        this.carrierVisit.setError(requiredError)
        isFormValid = false
      }
    }

    if (this.carrierVisit.error) {
      isFormValid = false
    }

    return isFormValid
  }

  setCarrierTypeChoice = (choice: ActionChoice) => {
    this.carrierTypeChoice = choice
  }

  setVisitChoice = (choice: ActionChoice) => {
    this.visitChoice = choice

    if (choice === 'edit') {
      this.setCarrierTypeChoice('edit')
    }

    if (choice === 'keep') {
      this.setCarrierTypeChoice('keep')
    }
  }

  get data() {
    return {
      carrierVisit: this.carrierVisit.data,
      carrierType: this.carrierType.data,
      finalDestination: this.finalDestination.data,
      inlandDestination: this.inlandDestination.data,
      portOfDischarge: this.portOfDischarge.data,
      stowageInstructions: this.stowageInstructions.data,
      approvalForLoading: this.approvalForLoading.data,
    }
  }
}
